import React, { useEffect, useState } from 'react';
import { getAccommodationBookings } from '../api/admin';

// Availability & Calendar — honest scope note: this is an upcoming
// check-in/check-out list, not a visual calendar grid. No calendar-grid
// component exists anywhere in this app yet (host/guest side included) —
// building one is real, separate frontend work, not something to fake here.
const AccommodationCalendar = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAccommodationBookings({ status: 'confirmed' }).then((res) => {
      const sorted = (res.data?.bookings || []).sort((a, b) => new Date(a.check_in) - new Date(b.check_in));
      setBookings(sorted);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div style={s.page}>
      <h1 style={s.h1}>Availability & Calendar</h1>
      <div style={s.note}>Showing upcoming check-ins/check-outs as a list. A visual calendar grid is not built yet.</div>
      {loading ? <p>Loading…</p> : (
        <table style={s.table}>
          <thead><tr><th style={s.th}>Listing</th><th style={s.th}>Check-in</th><th style={s.th}>Check-out</th><th style={s.th}>Guest</th></tr></thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b.id}>
                <td style={s.td}>{b.listing?.title}</td>
                <td style={s.td}>{b.check_in}</td>
                <td style={s.td}>{b.check_out}</td>
                <td style={s.td}>{b.guest?.full_name || b.guest?.email}</td>
              </tr>
            ))}
            {bookings.length === 0 && <tr><td style={s.td} colSpan={4}>No upcoming confirmed bookings.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
};

const s = {
  page: { padding: 24, maxWidth: 900 },
  h1: { fontSize: 22, fontWeight: 800, marginBottom: 10 },
  note: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: 10, borderRadius: 8, fontSize: 12.5, marginBottom: 16 },
  table: { width: '100%', borderCollapse: 'collapse', background: 'white', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #e5e7eb', color: '#6b7280', fontSize: 12 },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
};

export default AccommodationCalendar;
